module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": "请稍等···"
    }
  }, [_c('div', {
    staticClass: "page-container"
  }, [_c('AbnormalContainers', {
    attrs: {
      "abnormal-containers-list": _vm.namespaceAbnormalContainersList
    },
    on: {
      "refresh-list": _vm.getAbnormalContainers
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54016e08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/job_list/alarm/namespace_abnormal_containers.vue
// module id = 1409
// module chunks = 1